angular.module('mtic.components.dashboards.teacher_general').directive('classPerformanceTable', function ($log, $q, EventManager) {
      return {
            templateUrl: 'template.html',
            scope: {
                  students: '=students',
                  currentModule: '='
            },
            link: function (scope) {
                  var eventManager = new EventManager('teacherDashboard/classPerformanceTable', scope);
                  scope.zoomIn = function(student) {
                        eventManager.broadcast('teacher:selectStudent', student.user)
                  }
            }
      }
})
